import manualDialogCtrl from "./manualDialog/manualDialog.controller";
import manualDialogTemplate from "./manualDialog/manualDialog.html";

import adjustmentDialogCtrl from "./adjustmentDialog/adjustmentDialog.controller";
import adjustmentDialogTemplate from "./adjustmentDialog/adjustmentDialog.html";

import filter from "lodash/fp/filter";

import { formatKey } from "../../core/utils";

class Controller {
  constructor(
    $injector,
    $mdDialog,
    $stateParams,
    Invoice,
    Events,
    InvoiceTransforms,
    InvoiceItem,
    ActionLists
  ) {
    "ngInject";

    this.Events = Events;
    this.Invoice = Invoice;
    this.$mdDialog = $mdDialog;
    this.InvoiceItem = InvoiceItem;
    this.$stateParams = $stateParams;
    this.City = $injector.get("City");
    this.InvoiceTransforms = InvoiceTransforms;
    this.noteEvent = this.Events.getUpdateEvent("invoiceNote");

    this.invoiceItemParams = {
      invoice: this.$stateParams.id,
      isCityRequired: false,
    };
    this.invoiceItemActions = ActionLists.all.invoiceItemActions;
    this.invoiceItemFields = this.InvoiceTransforms.invoiceItemFields;
    this.invoiceItemTypes = ["manual_bonus", "manual_deduction", "payment"];
    this.cashCollectionStatus = $injector.get("Lists").all.cashCollectionStatus;

    this.showSuccessNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    const getConfirmDialog = (title, confirmClick) =>
      this.$mdDialog
        .confirm()
        .title(title)
        .ok(confirmClick || "Ok")
        .cancel("Cancel");

    const onAddNote = (options) => {
      const note = options.comment.value;

      this.Invoice.addNote(this.$stateParams.id, { note }).$promise.then(
        (response) => {
          this.invoice = this.InvoiceTransforms.justify(response);
          this.Events.emit(this.showSuccessNotificationEvent, {
            message: "Your note added successfully",
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    const invoiceTypes = (type) => {
      this.InvoiceItem.getTypes({
        category: type,
        active: true,
        isCityRequired: false,
      }).$promise.then((response) => {
        this.invoiceTypesList = response.hits;
      });
    };

    invoiceTypes(this.invoiceItemTypes);

    this.markAsPaid = () => {
      const confirm = getConfirmDialog(
        "Are you sure you want to mark this invoice as paid?"
      );

      this.$mdDialog.show(confirm).then(() => {
        this.Invoice.markPaid(this.$stateParams.id).$promise.then(
          () => {
            this.Events.emit(this.showSuccessNotificationEvent, {
              message: "Invoice marked as paid successfully",
            });
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      }, angular.noop);
    };

    this.Invoice.get(this.$stateParams.id).$promise.then((response) => {
      this.invoice = this.InvoiceTransforms.justify(response);
    });

    this.InvoiceItem.getAll({ invoice: this.$stateParams.id }).$promise.then(
      (response) => {
        this.invoiceItems = this.InvoiceTransforms.justifyItem(response.hits);
      }
    );

    this.Events.on(this.noteEvent, onAddNote);

    this.validateFinalize = (finalizeDate, pendingCashStatus) => {
      const finalDate = new Date(finalizeDate);
      return finalDate < new Date() && pendingCashStatus;
    };

    this.finalize = () => {
      this.Invoice.finalize(this.$stateParams.id)
        .$promise.then(() => {
          this.Events.emit(this.errorEvent, {
            message: "Invoice Finalized Successfully",
          });
        })
        .catch((err) => {
          this.Events.emit(this.errorEvent, { message: err.data.message });
        });
    };
    this.getSystemCategories();
  }

  adjustInvoice() {
    const adjust = this.$mdDialog.show({
      controller: adjustmentDialogCtrl,
      controllerAs: "$ctrl",
      template: adjustmentDialogTemplate,
      clickOutsideToClose: true,
      locals: {
        systemCategories: this.systemCategories,
      },
    });

    adjust.then((model) => {
      model.captain = this.invoice.captain._id;
      model.invoice = this.$stateParams.id;

      this.InvoiceItem.post(model).$promise.then(
        () => {
          this.Events.emit(this.showSuccessNotificationEvent, {
            message: "Invoice is adjusted successfully",
          });
        },
        (err) =>
          this.Events.emit(this.errorEvent, { message: err.data.message })
      );
    }, angular.noop);
  }

  openManualDialog(category, type = category) {
    const getManualCategory = (list) => list.category === category;
    const types = filter(getManualCategory)(this.invoiceTypesList);
    const confirm = this.$mdDialog.show({
      controller: manualDialogCtrl,
      controllerAs: "$ctrl",
      template: manualDialogTemplate,
      locals: {
        type,
        types,
        systemCategories: this.systemCategories,
      },
    });

    confirm.then((obj) => {
      obj.captain = this.invoice.captain._id;
      obj.invoice = this.$stateParams.id;

      this.InvoiceItem.post(obj).$promise.then(
        () => {
          this.Events.emit(this.showSuccessNotificationEvent, {
            message: `${formatKey(category)} invoice created successfully`,
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    }, angular.noop);
  }
  getSystemCategories() {
    this.systemCategories = [];
    this.City.getRideCategory().$promise.then((response) => {
      if (response.hits) {
        this.systemCategories = response.hits.map(
          ({ _id: id, _source: category }) => ({
            id,
            title: `${category.ride_type} ${category.service_type}`,
          })
        );
      }
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/invoice/invoice.controller.js